import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedEvaluatorRoute = () => {
  const data: any = localStorage.getItem("data")
    ? JSON.parse(localStorage.getItem("data") as any)
    : null;
  const roleData = data;
  console.log("role data", roleData);
  return data?.token ? (
    roleData?.role?.role_code == "STATE_EVALUATOR" ||
    roleData?.role?.role_code == "DISTRICT_EVALUATOR" ||
    roleData?.role?.role_code == "NATIONAL_EVALUATOR" ? (
      <Outlet />
    ) : (
      <Navigate to="/" />
    )
  ) : (
    <Navigate to="/account/login" />
  );
};

export default ProtectedEvaluatorRoute;
